export default "__VITE_ASSET__CVX3O8Lf__"